import useApi from '../../services/api/useApi';
import useAuthToken from './useAuthToken';
import useStoreWhereLoggedIn from './useStoreWhereLoggedIn';
import useAuthCookie from './useAuthCookie';

export const USER_IN_SESSION_KEY = 'userWithSession';

const useAuthUser = () => {
  const api = useApi();
  const { setToken } = useAuthToken();
  const { setStore } = useStoreWhereLoggedIn();
  const { getUserInSessionCookie, setUserInSessionCookie, removeUserInSessionCookie } =
    useAuthCookie();

  const storeUser = (userWithAddress: UserWithAddress) => {
    setUserInSessionCookie(userWithAddress);
  };

  const getUser = () => {
    const cookieUser = getUserInSessionCookie();
    if (cookieUser) {
      return cookieUser;
    }
    return null;
  };

  const remove = () => {
    removeUserInSessionCookie();
    // Remove this call after a while. They're being left to remove any info from the previous cross store solution.
    localStorage.removeItem(USER_IN_SESSION_KEY);
  };

  const loginUser = async ({ storeId, user, ...sessionData }: SessionData) => {
    setToken(sessionData);
    setStore(storeId);
    api.addAuthorizationHeader(sessionData.accessToken);
    storeUser(user ?? (await api.getUser()).user);
  };

  return { getUser, storeUser, remove, loginUser };
};

export default useAuthUser;
